import { Icon } from "@uigovpe/components";

const feedbackSteps = [
  {
    label: "Status",
    value: "Em análise",
    marker: "bg-[#f2b705]!",
  },
  {
    label: "Publicação",
    value: "Após aprovação",
  },
  {
    label: "Acompanhamento",
    value: "Via E-mail",
  },
];

export default function ProfileFeedbackRegisterPage() {
  return (
    <main className="flex! min-h-[calc(100vh-9rem)]! items-center! justify-center! px-4! py-10!">
      <section className="w-full! max-w-[760px]! rounded-xl! border! border-zinc-100! bg-white! px-7! py-8! text-center! shadow-xl! md:px-10!">
        <div className="mx-auto! flex! size-20! items-center! justify-center! rounded-full! bg-primary! shadow-sm!">
          <Icon
            icon="schedule"
            outline
            className="text-[34px]! leading-none! text-white!"
          />
        </div>

        <div className="mx-auto! mt-5! flex! max-w-[520px]! flex-col! items-center! gap-3!">
          <h1 className="text-xl! font-bold! text-[#28272c]!">
            Cadastro enviado para análise
          </h1>
          <p className="text-sm! leading-relaxed! text-zinc-600!">
            Seus dados foram enviados com sucesso. Nossa equipe está revisando
            as informações, você será notificada assim que o processo for
            concluído.
          </p>
        </div>

        <div className="mt-8! grid! overflow-hidden! rounded-md! bg-[#eceff2]! text-left! sm:grid-cols-3!">
          {feedbackSteps.map((step, index) => (
            <div
              key={step.label}
              className={`flex! min-h-[58px]! flex-col! justify-center! gap-1! px-8! py-3! ${
                index > 0
                  ? "border-t! border-zinc-300! sm:border-t-0! sm:border-l!"
                  : ""
              }`}
            >
              <span className="text-[11px]! leading-none! text-zinc-500!">
                {step.label}
              </span>
              <strong className="flex! items-center! gap-2! text-xs! font-semibold! text-[#28272c]!">
                {step.marker ? (
                  <span
                    className={`size-2! rounded-full! ${step.marker}`}
                    aria-hidden="true"
                  />
                ) : null}
                {step.value}
              </strong>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}
